// Getters
export const PLANNED_OKR_TOTALIZER = "okr/PLANNED_OKR_TOTALIZER";
export const OKR_OVERVIEW_TOTALIZER = "okr/OKR_OVERVIEW_TOTALIZER";
export const PLANNED_OKR_LIST = "okr/PLANNED_OKR_LIST";
export const OKR_OVERVIEW_LIST = "okr/OKR_OVERVIEW_LIST";
export const HISTORICAL_PERFORMANCE = "okr/HISTORICAL_PERFORMANCE";

// Mutations
export const MUTATE_PLANNED_OKR_TOTALIZER = "okr/MUTATE_PLANNED_OKR_TOTALIZER";
export const MUTATE_PLANNED_OKR_LIST = "okr/MUTATE_PLANNED_OKR_LIST";
export const MUTATE_OKR_OVERVIEW_TOTALIZER =
  "okr/MUTATE_OKR_OVERVIEW_TOTALIZER";
export const MUTATE_OKR_OVERVIEW_LIST = "okr/MUTATE_OKR_OVERVIEW_LIST";
export const MUTATE_HISTORICAL_PERFORMANCE =
  "okr/MUTATE_HISTORICAL_PERFORMANCE";
export const MUTATE_INTERVIEW_EFFICIENCY_BY_KEY = "okr/MUTATE_INTERVIEW_EFFICIENCY_BY_KEY";

// Actions
export const SAVE_PLANNED_OKR = "okr/SAVE_PLANNED_OKR";
export const GET_PLANNED_OKR = "okr/GET_PLANNED_OKR";
export const GET_PLANNED_OKR_TOTALIZER = "okr/GET_PLANNED_OKR_TOTALIZER";
export const GET_CONSULTANT_EP_PERCENTAGE = "okr/GET_CONSULTANT_EP_PERCENTAGE";
export const GET_RANGE_DATES = "okr/GET_RANGE_DATES";
export const SEARCH_PLANNED_OKR_LIST = "okr/SEARCH_PLANNED_OKR_LIST";
export const GET_SCOPE_OPTIONS = "okr/GET_SCOPE_OPTIONS";
export const GET_MONTHS_INTERVAL = "okr/GET_MONTHS_INTERVAL";
export const GET_PRO_LABORE_TOTAL = "okr/GET_PRO_LABORE_TOTAL";
export const GET_GOALS_FUNNEL_GRAPH_DATA = "okr/GET_GOALS_FUNNEL_GRAPH_DATA";
export const GET_INTERVIEW_EFFICIENCY_GRAPH_DATA =
  "okr/GET_INTERVIEW_EFFICIENCY_GRAPH_DATA";
export const GET_CURRENT_PERFORMANCE_TABLE_DATA =
  "okr/GET_CURRENT_PERFORMANCE_TABLE_DATA";
export const GET_OKR_OVERVIEW_TOTALIZER = "okr/OKR_OVERVIEW_TOTALIZER";
export const SEARCH_OKR_OVERVIEW_LIST = "okr/SEARCH_OKR_OVERVIEW_LIST";
export const GET_CURRENT_PERFORMANCE_CONSULTANT =
  "okr/GET_CURRENT_PERFORMANCE_CONSULTANT";
export const GET_HISTORICAL_PERFORMANCE = "okr/GET_HISTORICAL_PERFORMANCE";
export const GET_HAS_FILLED_OKR = "okr/GET_HAS_FILLED_OKR";
export const GET_OKR_PREMISES = "okr/GET_OKR_PREMISES";
export const UPDATE_OKR_PREMISES = "okr/UPDATE_OKR_PREMISES";
export const GET_BONUS_TIERS = "okr/GET_BONUS_TIERS";
export const GET_SUBSCRIPTION_PACKAGES = "okr/GET_SUBSCRIPTION_PACKAGES";
export const GET_CONSULTANT_COMMISSION_RATES = "okr/GET_CONSULTANT_COMMISSION_RATES";
export const GET_WEEKLY_TRACKING = "okr/GET_WEEKLY_TRACKING";
export const GET_CONSTANCY_TABLE = "okr/GET_CONSTANCY_TABLE";
export const SAVE_ACTION_PLAN = "okr/SAVE_ACTION_PLAN";
